import { classNames } from '@dimjs/utils';
import { CSSProperties } from 'react';
import { px2rem } from '../utils';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';

export type TagProps = {
  color?: 'primary' | 'success' | 'warning' | 'danger' | (string & {});
  fill?: 'solid' | 'outline';
  onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  children?: React.ReactNode;
  size?: 'small' | 'middle' | 'large';
  /**
   * number => 组件会进行px2rem
   * string => 直接赋值，需要外部自行转换，例如：`${px2rem(20)}px ${px2rem(10)}px`
   */
  borderRadius?: number | string;
} & CommonPropsWithChildren<{ '--tag-border-radius': CSSProperties['borderRadius'] }>;

const colorRecord: Record<string, string> = {
  primary: 'var(--v-color-primary)',
  success: 'var(--v-color-success)',
  warning: 'var(--v-color-warning)',
  danger: 'var(--v-color-danger)',
};

export const Tag = (props: TagProps) => {
  const color = colorRecord[props.color || 'primary'] ?? props.color;

  // props style 优先级更高
  const style = {
    '--tag-color': color,
    '--tag-border-radius':
      typeof props.borderRadius === 'number' ? px2rem(props.borderRadius) : props.borderRadius,
  } as CSSProperties;

  const className = classNames('v-tag', `v-tag-${props.size || 'small'}`, `v-tag-${props.fill || 'solid'}`);

  return withNativeProps(
    props,
    <span style={style} className={className} onClick={props.onClick}>
      {props.children}
    </span>,
  );
};
